var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4.5,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 4.5,
    r: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,7h-29C1.224,7,1,6.776,1,6.5S1.224,6,1.5,6h29C30.776,6,31,6.224,31,6.5S30.776,7,30.5,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5,22C1.224,22,1,21.776,1,21.5v-18C1,2.673,1.673,2,2.5,2h27C30.327,2,31,2.673,31,3.5v9     c0,0.276-0.224,0.5-0.5,0.5S30,12.776,30,12.5v-9C30,3.225,29.776,3,29.5,3h-27C2.224,3,2,3.225,2,3.5v18     C2,21.776,1.776,22,1.5,22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22,31H10.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h1c0.827,0,1.5-0.673,1.5-1.5v-1    c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v1c0,0.563-0.187,1.082-0.501,1.5h5.002C18.187,29.582,18,29.063,18,28.5v-3    c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v3c0,0.827,0.673,1.5,1.5,1.5H22c0.276,0,0.5,0.224,0.5,0.5S22.276,31,22,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,26h-16C1.673,26,1,25.327,1,24.5v-3C1,21.224,1.224,21,1.5,21h14c0.276,0,0.5,0.224,0.5,0.5    S15.776,22,15.5,22H2v2.5C2,24.775,2.224,25,2.5,25h16c0.276,0,0.5,0.224,0.5,0.5S18.776,26,18.5,26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,14h-1c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h1c0.276,0,0.5,0.224,0.5,0.5     S18.776,14,18.5,14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,10h-10C17.224,10,17,9.776,17,9.5S17.224,9,17.5,9h10C27.776,9,28,9.224,28,9.5S27.776,10,27.5,10z     "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,12h-10c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10c0.276,0,0.5,0.224,0.5,0.5     S27.776,12,27.5,12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,14h-3C4.224,14,4,13.776,4,13.5S4.224,13,4.5,13h3C7.776,13,8,13.224,8,13.5S7.776,14,7.5,14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,10h-10C4.224,10,4,9.776,4,9.5S4.224,9,4.5,9h10C14.776,9,15,9.224,15,9.5S14.776,10,14.5,10z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,12h-10C4.224,12,4,11.776,4,11.5S4.224,11,4.5,11h10c0.276,0,0.5,0.224,0.5,0.5S14.776,12,14.5,12z     "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24,27c-3.86,0-7-3.141-7-7s3.14-7,7-7c1.352,0,2.663,0.386,3.792,1.115       c0.232,0.15,0.298,0.459,0.148,0.691c-0.15,0.23-0.458,0.3-0.691,0.148C26.283,14.33,25.159,14,24,14c-3.309,0-6,2.691-6,6       s2.691,6,6,6s6-2.691,6-6c0-0.642-0.101-1.273-0.299-1.877c-0.086-0.263,0.057-0.545,0.319-0.631       c0.262-0.088,0.545,0.057,0.631,0.318C30.882,18.516,31,19.252,31,20C31,23.859,27.86,27,24,27z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22.699c-0.004,0-0.008,0-0.012,0c-0.145-0.004-0.28-0.069-0.373-0.18l-2.5-3       c-0.176-0.213-0.147-0.528,0.064-0.705c0.213-0.176,0.527-0.147,0.705,0.064l2.133,2.561l6.215-6.865       c0.188-0.204,0.504-0.216,0.706-0.031c0.203,0.187,0.217,0.503,0.03,0.707l-6.6,7.287C23.773,22.641,23.641,22.699,23.5,22.699       z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.8362f9b44bf0c930311ea607f774bcc8.svg";
export { ForwardRef as ReactComponent };